import React from "react";
import { Box, Button } from "@mui/material";
import { useTranslation } from "react-i18next";

export default function LanguageSelector() {
  const { i18n } = useTranslation();

  const changeLanguage = (lng: string) => {
    i18n.changeLanguage(lng);
  };

  return (
    <Box
      sx={{
        display: "inline-flex",
        alignItems: "center",
        border: "1px solid #CBD5E1",
        borderRadius: "999px",
        padding: "2px",
        backgroundColor: "#FFFFFF",
      }}
    >
      <Button
        disableRipple
        onClick={() => changeLanguage("es")}
        sx={{
          minWidth: "38px",
          height: "28px",
          borderRadius: "999px",
          textTransform: "uppercase",
          fontSize: "0.75rem",
          fontWeight: 600,

          color: i18n.language === "es" ? "#1F2937" : "#94A3B8",
          backgroundColor:
            i18n.language === "es" ? "#F1F5F9" : "transparent",

          "&:hover": {
            backgroundColor:
              i18n.language === "es" ? "#F1F5F9" : "#F8FAFC",
          },
        }}
      >
        ES
      </Button>

      <Button
        disableRipple
        onClick={() => changeLanguage("en")}
        sx={{
          minWidth: "38px",
          height: "28px",
          borderRadius: "999px",
          textTransform: "uppercase",
          fontSize: "0.75rem",
          fontWeight: 600,

          color: i18n.language === "en" ? "#1F2937" : "#94A3B8",
          backgroundColor:
            i18n.language === "en" ? "#F1F5F9" : "transparent",

          "&:hover": {
            backgroundColor:
              i18n.language === "en" ? "#F1F5F9" : "#F8FAFC",
          },
        }}
      >
        EN
      </Button>

      <Button
        disableRipple
        onClick={() => changeLanguage("pt")}
        sx={{
          minWidth: "38px",
          height: "28px",
          borderRadius: "999px",
          textTransform: "uppercase",
          fontSize: "0.75rem",
          fontWeight: 600,

          color: i18n.language === "pt" ? "#1F2937" : "#94A3B8",
          backgroundColor:
            i18n.language === "pt" ? "#F1F5F9" : "transparent",

          "&:hover": {
            backgroundColor:
              i18n.language === "pt" ? "#F1F5F9" : "#F8FAFC",
          },
        }}
      >
        PT
      </Button>
    </Box>
  );
}
